import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { API } from "src/app/services/api";

export interface VerificarElegibilidadeResponse {
  elegivel: boolean;
  parcelasEmAberto: number;
  parcelasPagas: number;
  parcelasVencidas: number;
  saldoDevido: number;
  mensagem: string;
}

export interface MudarPlanoRequest {
  matriculaAlunoId: number;
  novoPlanoPagamentoId: number;
  tipoPagamentoNovo: number;
  tefNsu?: string;
  tefAutorizacao?: string;
  tefValor?: number;
  tefParcelas?: number;
  unidadeLogadoId: number;
  observacao?: string;
}

export interface MudarPlanoResponse {
  sucesso: boolean;
  historicoMudancaId: number;
  parcelasCanceladas: number;
  parcelasCriadas: number;
  valorTotalAnterior: number;
  valorTotalNovo: number;
  dataAlteracao: Date;
  mensagem: string;
}

@Injectable({
  providedIn: "root"
})
export class MudancaPlanoService {
  constructor(private http: HttpClient) {}

  verificarElegibilidade(
    matriculaAlunoId: number,
    unidadeLogadoId: number
  ): Observable<VerificarElegibilidadeResponse> {
    const params = new HttpParams()
      .set("unidadeLogadoId", unidadeLogadoId.toString());

    const url = `${environment.baseUrl.replace(/\/$/, '')}/api/MudancaPlano/${matriculaAlunoId}/elegibilidade`;
    return this.http.get<VerificarElegibilidadeResponse>(url, { params });
  }

  executarMudancaPlano(
    request: MudarPlanoRequest
  ): Observable<MudarPlanoResponse> {
    const url = `${environment.baseUrl.replace(/\/$/, '')}/api/MudancaPlano/executar`;
    return this.http.post<MudarPlanoResponse>(url, {
      matriculaAlunoId: request.matriculaAlunoId,
      planoNovoId: request.novoPlanoPagamentoId,
      tipoPagamentoNovo: request.tipoPagamentoNovo,
      usuarioIdResponsavel: request.unidadeLogadoId,
      usuarioNomeResponsavel: "",
      motivacao: request.observacao
    });
  }

  registrarPosComposicao(request: {
    matriculaAlunoId: number;
    novoPlanoPagamentoId: number;
    composicaoId: number;
    parcelasParaCancelar: number[];
    motivoMudancaPlano?: string;
    usuarioLogadoId?: number;
  }): Observable<any> {
    const url = `${environment.baseUrl.replace(/\/$/, '')}${API.mudancaplano.registrarPosComposicao}`;
    return this.http.post<any>(url, request);
  }
}
